import React, { useRef, useState, useEffect } from 'react';
import clsx from 'clsx';

const Sunrise = () => {
  const container = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const { current } = container;

    if (!current) return undefined;

    const observer = new IntersectionObserver((entries) => {
      entries.some((entry) => setIsVisible((prev) => prev || entry.isIntersecting));
    });
    observer.observe(current);

    return () => observer.unobserve(current);
  }, []);

  return (
    <div className="sunrise-container" ref={container}>
      <div className={clsx('sun-background', { visible: isVisible })} />
      <div className={clsx('sun', { visible: isVisible })} />
      <div className="sun-ray" />
    </div>
  );
};

export default Sunrise;
